const seekerInitialState = {
    //product-type
    loadingProductTypeApi: true,
    findProductTypeDataError: "",
    findProductTypeData: [],

    //shipment-type
    loadingShipmentTypeApi: true,
    findShipmentTypeData: [],
    findShipmentTypeDataError: "",

    //shipment-mode
    loadingShipmentModeApi: true,
    findShipmentModeData: [],
    findShipmentModeDataError: "",

    //shipment-via
    loadingShipmentViaApi: true,
    findShipmentViaData: [],
    findShipmentViaDataError: "",

    //cargo-type
    loadingCargoTypeApi: true,
    findCargoTypeData: [],
    findCargoTypeDataError: "",

    //department type
    loadingDepartmentTypeApi: true,
    findDepartmentTypeData: [],
    findDepartmentTypeDataError: "",

    //id proof type
    loadingIdProofTypeApi: true,
    findIdProofTypeData: [],
    findIdProofTypeDataError: "",

    //package type
    loadingPackageTypeApi: true,
    findPackageTypeData: [],
    findPackageTypeDataError: "",

    //gender type
    loadingGenderTypeApi: true,
    findGenderTypeData: [],
    findGenderTypeDataError: "",

    //designation type
    loadingDesignationTypeApi: true,
    findDesignationTypeData: [],
    findDesignationTypeDataError: "",

    //weight unit
    loadingWeightUnitTypeApi: true,
    findWeightUnitTypeData: [],
    findWeightUnitTypeDataError: "",

    //required service
    loadingRequiredServiceTypeApi: true,
    findRequiredServiceTypeData: [],
    findRequiredServiceTypeDataError: "",

    //view-rates
    loadingViewRate: true,
    viewRateData: [],
    viewRateError: "",

    //download quotation
    loadingDownloadQuotation: true,
    DownloadQuotationData: [],
    DownloadQuotationDataError: "",

    //profile page
    loadingProfile: true,
    ProfileData: [],
    ProfileDataError: "",

    //origin country
    loadingOriginCountry: false,
    originCountryDataError: "",
    originCountryData: [],

    // origin state
    loadingOriginState: false,
    originStateDataError: "",
    originStateData: [],

    // origincity
    loadingOriginCity: false,
    originCityDataError: "",
    originCityData: [],

    //destination country
    loadingDestinationCountry: false,
    destinationCountryDataError: "",
    destinationCountryData: [],

    // destination state
    loadingDestinationState: false,
    destinationStateDataError: "",
    destinationStateData: [],

    // destination city
    loadingDestinationCity: false,
    destinationCityDataError: "",
    destinationCityData: [],

    //incoterms
    loadingIncoterms: false,
    incotermsDataError: "",
    incotermsData: [],

    //chargehead
    loadingChargehead: false,
    chargeheadDataError: "",
    chargeheadData: [],

    //chargehead by service
    loadingChargeheadByService: false,
    ChargeheadByServiceDataError: "",
    ChargeheadByServiceData: [],

    //additionals
    loadingAdditionals: false,
    additionalsDataError: "",
    additionalsData: [],

    //commodity
    loadingCommodity: false,
    commodityDataError: "",
    commodityData: [],

    //currency
    loadingCurrency: false,
    currencyDataError: "",
    currencyData: [],

    //container type
    loadingContainertype: false,
    containertypeDataError: "",
    containertypeData: [],

    //container size
    loadingContainersize: false,
    containersizeDataError: "",
    containersizeData: [],

    //kycDoc list
    loadingKycDocApi: false,
    kycDocDataError: "",
    kycDocData: [],

    //kycDoc view
    loadingKycDocViewApi: false,
    kycDocViewDataError: "",
    kycDocViewData: [],

    //country
    loadingMasterCountry: false,
    MasterCountry: [],
    MasterCountryError: "",
    MasterCountryCurrentPage: 0,
    MasterCountryTotalPage: 0,
    MasterCountryTotalData: 0,

    //country view
    loadingMasterCountryDetail: false,
    MasterCountryDetail: {},
    MasterCountryDetailError: "",

    //state
    loadingMasterState: false,
    MasterState: [],
    MasterStateError: "",
    MasterStateCurrentPage: 0,
    MasterStateTotalPage: 0,
    MasterStateTotalData: 0,

    //state view
    loadingMasterStateDetail: false,
    MasterStateDetail: {},
    MasterStateDetailError: "",

    //city
    loadingMasterCity: false,
    MasterCity: [],
    MasterCityError: "",
    MasterCityCurrentPage: 0,
    MasterCityTotalPage: 0,
    MasterCityTotalData: 0,

    //city view
    loadingMasterCityDetail: false,
    MasterCityDetail: {},
    MasterCityDetailError: "",

    //state by country list
    loadingMasterStateByCountryList: false,
    MasterStateByCountryList: [],
    MasterStateByCountryListError: "",
    //state by GST country list
    loadingMasterStateByGSTCountryList: false,
    MasterStateByGSTCountryList: [],
    MasterStateByGSTCountryListError: "",

    //ciity by state list
    loadingMasterCityByStateList: false,
    MasterCityByStateList: [],
    MasterCityByStateListError: "",

    //airport
    loadingMasterAirport: false,
    MasterAirport: [],
    MasterAirportError: "",
    MasterAirportCurrentPage: 0,
    MasterAirportTotalPage: 0,
    MasterAirportTotalData: 0,

    //airport view
    loadingMasterAirportDetail: false,
    MasterAirportDetail: {},
    MasterAirportDetailError: "",

    //seaport
    loadingMasterSeaport: false,
    MasterSeaport: [],
    MasterSeaportError: "",
    MasterSeaportCurrentPage: 0,
    MasterSeaportTotalPage: 0,
    MasterSeaportTotalData: 0,

    //seaport view
    loadingMasterSeaportDetail: false,
    MasterSeaportDetail: {},
    MasterSeaportDetailError: "",

    //airline
    loadingMasterAirline: false,
    MasterAirline: [],
    MasterAirlineError: "",
    MasterAirlineCurrentPage: 0,
    MasterAirlineTotalPage: 0,
    MasterAirlineTotalData: 0,

    //airline view
    loadingMasterAirlineDetail: false,
    MasterAirlineDetail: {},
    MasterAirlineDetailError: "",

    //shipline
    loadingMasterShipline: false,
    MasterShipline: [],
    MasterShiplineError: "",
    MasterShiplineCurrentPage: 0,
    MasterShiplineTotalPage: 0,
    MasterShiplineTotalData: 0,

    //shipline view
    loadingMasterShiplineDetail: false,
    MasterShiplineDetail: {},
    MasterShiplineDetailError: "",

    //expense type
    loadingExpenseType: false,
    ExpenseTypeData: [],
    ExpenseTypeDataError: "",

    //customer details by suername
    loadingCustomerDetailbyUsername: false,
    CustomerDetailbyUsername: {},
    CustomerDetailbyUsernameError: "",

    //iata agent list
    loadingMasterIATAAgentList: true,
    MasterIATAAgentList: [],
    MasterIATAAgentListError: "",
    MasterIATAAgentListCurrentPage: 0,
    MasterIATAAgentListTotalPage: 0,
    MasterIATAAgentListTotalData: 0,

    //iata agent detail
    loadingMasterIATAAgentDetail: true,
    MasterIATAAgentDetail: null,
    MasterIATAAgentDetailError: "",

    //iata agent bank list
    loadingMasterIATAAgentAddressList: true,
    MasterIATAAgentAddressList: [],
    MasterIATAAgentAddressListError: "",

    //iata agent bank detail
    loadingMasterIATAAgentAddressDetail: true,
    MasterIATAAgentAddressDetail: null,
    MasterIATAAgentAddressDetailError: "",

    //iata agent sales list
    loadingMasterIATAAgentSalesList: true,
    MasterIATAAgentSalesList: [],
    MasterIATAAgentSalesListError: "",

    //iata agent sales detail
    loadingMasterIATAAgentSalesDetail: true,
    MasterIATAAgentSalesDetail: null,
    MasterIATAAgentSalesDetailError: "",

    //iata agent customer list
    loadingMasterIATAAgentCustomerList: true,
    MasterIATAAgentCustomerList: [],
    MasterIATAAgentCustomerListError: "",

    //iata agent customer detail
    loadingMasterIATAAgentCustomerDetail: true,
    MasterIATAAgentCustomerDetail: null,
    MasterIATAAgentCustomerDetailError: "",

    //iata agent contact list
    loadingMasterIATAAgentContactList: true,
    MasterIATAAgentContactList: [],
    MasterIATAAgentContactListError: "",

    //iata agent contact detail
    loadingMasterIATAAgentContactDetail: true,
    MasterIATAAgentContactDetail: null,
    MasterIATAAgentContactDetailError: "",

    //iata agent get
    loadingMasterIATAAgent: true,
    MasterIATAAgent: null,
    MasterIATAAgentError: "",

    //iata agent bank list
    loadingMasterAirlineAddressList: true,
    MasterAirlineAddressList: [],
    MasterAirlineAddressListError: "",

    //iata agent bank detail
    loadingMasterAirlineAddressDetail: true,
    MasterAirlineAddressDetail: null,
    MasterAirlineAddressDetailError: "",

    //airline list
    loadingMasterAirlineList: true,
    MasterAirlineList: [],
    MasterAirlineListError: "",

    //airline address by airline list
    loadingAirlineAddressByAirlineList: true,
    AirlineAddressByAirlineList: [],
    AirlineAddressByAirlineListError: "",

    //iata agent list
    loadingIATAAgentList: true,
    IATAAgentList: [],
    IATAAgentListError: "",

    //iata agent address by iata agent list
    loadingIATAAgentAddressByIATAAgentList: true,
    IATAAgentAddressByIATAAgentList: [],
    IATAAgentAddressByIATAAgentListError: "",

    //rate class list
    loadingMasterRateclassList: false,
    MasterRateclassList: [],
    MasterRateclassListError: "",
    MasterRateclassListCurrentPage: 0,
    MasterRateclassListTotalPage: 0,
    MasterRateclassListTotalData: 0,

    loadingMasterRateclassDetail: false,
    MasterRateclassDetail: {},
    MasterRateclassDetailError: "",

    loadingRateclassList: false,
    RateclassList: [],
    RateclassListError: "",

    loadingSpecializationApi: false,
    findSpecializationData: [],
    findSpecializationDataError: "",

    loadingLicenseTypeApi: false,
    findLicenseTypeData: [],
    findLicenseTypeDataError: "",

    loadingVehicleTypeApi: false,
    findVehicleTypeData: [],
    findVehicleTypeDataError: "",

    loadingSpecializationActiveApi: false,
    findSpecializationActiveData: [],
    findSpecializationActiveDataError: "",

    loadingLicenseTypeActiveApi: false,
    findLicenseTypeActiveData: [],
    findLicenseTypeActiveDataError: "",

    loadingVehicleTypeActiveApi: false,
    findVehicleTypeActiveData: [],
    findVehicleTypeActiveDataError: "",

    // -----------ACCOUNT MASTER------------

    // parent group
    loadingMasterAccountParentGroup: false,
    MasterAccountParentGroup: [],
    MasterAccountParentGroupError: "",
    MasterAccountParentGroupCurrentPage: 0,
    MasterAccountParentGroupTotalPage: 0,
    MasterAccountParentGroupTotalData: 0,

    loadingMasterAccountParentGroupName: false,
    MasterAccountParentGroupName: [],
    MasterAccountParentGroupNameError: "",

    // get all ledger account party name

    loadingLedgerAccountIdAndPartyName: false,
    LedgerAccountIdAndPartyName: [],
    LedgerAccountIdAndPartyNameError: "",

    // group type
    loadingMasterAccountGroupType: false,
    MasterAccountGroupType: [],
    MasterAccountGroupTypeError: "",
    MasterAccountGroupTypeCurrentPage: 0,
    MasterAccountGroupTypeTotalPage: 0,
    MasterAccountGroupTypeTotalData: 0,

    loadingMasterAccountGroupTypeName: false,
    MasterAccountGroupTypeName: [],
    MasterAccountGroupTypeNameError: "",

    //SUB  group type
    loadingMasterAccountSubGroupType: false,
    MasterAccountSubGroupType: [],
    MasterAccountSubGroupTypeError: "",
    MasterAccountSubGroupTypeCurrentPage: 0,
    MasterAccountSubGroupTypeTotalPage: 0,
    MasterAccountSubGroupTypeTotalData: 0,

    loadingMasterAccountSubGroupTypeName: false,
    MasterAccountSubGroupTypeName: [],
    MasterAccountSubGroupTypeNameError: "",

    // -------------------group master----------------------
    loadingGroupMaster: false,
    GroupMaster: [],
    GroupMasterError: "",
    GroupMasterCurrentPage: 0,
    GroupMasterTotalPage: 0,
    GroupMasterTotalData: 0,

    loadingGroupMasterName: false,
    GroupMasterName: [],
    GroupMasterNameError: "",

    //   ---------------------LEDGER ACCOUNT -------------------------
    // ledger group type
    loadingMasterAccounLedgerGroupType: false,
    MasterAccounLedgerGroupType: [],
    MasterAccounLedgerGroupTypeError: "",
    MasterAccounLedgerGroupTypeCurrentPage: 0,
    MasterAccounLedgerGroupTypeTotalPage: 0,
    MasterAccounLedgerGroupTypeTotalData: 0,

    loadingMasterAccounLedgerGroupTypeName: false,
    MasterAccounLedgerGroupTypeName: [],
    MasterAccounLedgerGroupTypeNameError: "",

    // tds category
    loadingMasterAccounTdsCategory: false,
    MasterAccounTdsCategory: [],
    MasterAccounTdsCategoryError: "",
    MasterAccounTdsCategoryCurrentPage: 0,
    MasterAccounTdsCategoryTotalPage: 0,
    MasterAccounTdsCategoryTotalData: 0,

    loadingMasterAccounTdsCategoryName: false,
    MasterAccounTdsCategoryName: [],
    MasterAccounTdsCategoryNameError: "",

    // tds category
    loadingMasterAccountGroup: false,
    MasterAccountGroup: [],
    MasterAccountGroupError: "",
    MasterAccountGroupCurrentPage: 0,
    MasterAccountGroupTotalPage: 0,
    MasterAccountGroupTotalData: 0,

    loadingMasterAccountGroupName: false,
    MasterAccountGroupName: [],
    MasterAccountGroupNameError: "",

    // CASH BOOK
    loadingMasterCashBook: false,
    MasterCashBook: [],
    MasterCashBookError: "",
    MasterCashBookCurrentPage: 0,
    MasterCashBookTotalPage: 0,
    MasterCashBookTotalData: 0,

    loadingMasterCashBookName: false,
    MasterCashBookName: [],
    MasterCashBookNameError: "",

    // branch
    loadingMasterBranch: false,
    MasterBranch: [],
    MasterBranchError: "",
    MasterBranchCurrentPage: 0,
    MasterBranchTotalPage: 0,
    MasterBranchTotalData: 0,

    loadingMasterBranchName: false,
    MasterBranchName: [],
    MasterBranchNameError: "",

    // tax master
    loadingMasterTaxMaster: false,
    MasterTaxMaster: [],
    MasterTaxMasterError: "",
    MasterTaxMasterCurrentPage: 0,
    MasterTaxMasterTotalPage: 0,
    MasterTaxMasterTotalData: 0,

    loadingMasterTaxMasterName: false,
    MasterTaxMasterName: [],
    MasterTaxMasterNameError: "",

    loadingMasterTaxMasterCountries: false,
    MasterTaxMasterCountries: [],
    MasterTaxMasterCountriesError: "",

    loadingMasterTaxMasterCountryStates: false,
    MasterTaxMasterCountryStates: [],
    MasterTaxMasterCountryStatesError: "",

    loadingMasterTaxMasterData: false,
    MasterTaxMasterData: {},
    MasterTaxMasterDataError: "",

    // cost - center
    loadingMasterCostCenter: false,
    MasterCostCenter: [],
    MasterCostCenterError: "",
    MasterCostCenterCurrentPage: 0,
    MasterCostCenterTotalPage: 0,
    MasterCostCenterTotalData: 0,

    loadingMasterCostCenterName: false,
    MasterCostCenterName: [],
    MasterCostCenterNameError: "",

    // committed bank
    loadingMasterCommittedBank: false,
    MasterCommittedBank: [],
    MasterCommittedBankError: "",
    MasterCommittedBankCurrentPage: 0,
    MasterCommittedBankTotalPage: 0,
    MasterCommittedBankTotalData: 0,

    loadingMasterCommittedBankName: false,
    MasterCommittedBankName: [],
    MasterCommittedBankNameError: "",


    // rcm category
    loadingMasterRcmCategory: false,
    MasterRcmCategory: [],
    MasterRcmCategoryError: "",
    MasterRcmCategoryCurrentPage: 0,
    MasterRcmCategoryTotalPage: 0,
    MasterRcmCategoryTotalData: 0,

    loadingMasterRcmCategoryName: false,
    MasterRcmCategoryName: [],
    MasterRcmCategoryNameError: "",

    //   currency master -> masters lists//
    loadingMasterCurrency: false,
    MasterCurrency: [],
    MasterCurrencyError: "",
    MasterCurrencyCurrentPage: 0,
    MasterCurrencyTotalPage: 0,
    MasterCurrencyTotalData: 0,

    loadingMasterCurrencyIdAndName: false,
    MasterCurrencyIdAndName: [],
    MasterCurrencyIdAndNameError: "",

    //   company info vis gst
    loadingCompanyInfoViaGst: false,
    CompanyInfoViaGst: [],
    CompanyInfoViaGstError: "",


    // ReceiptVoucher -> search//
    loadingReceiptVoucher: false,
    ReceiptVoucher: [],
    ReceiptVoucherError: "",
    ReceiptVoucherCurrentPage: 0,
    ReceiptVoucherTotalPage: 0,
    ReceiptVoucherTotalData: 0,


    // Period lock -> //
    loadingPeriodLock: false,
    PeriodLock: [],
    PeriodLockError: "",
    PeriodLockCurrentPage: 0,
    PeriodLockTotalPage: 0,
    PeriodLockTotalData: 0,
};

const MasterReducer = (state = seekerInitialState, action) => {
    switch (action.type) {
        //product-type//
        case 'FIND_PRODUCT_PAGE_REQUEST':
            return {
                ...state,
                loadingProductTypeApi: true,
                findProductTypeData: "",
                findProductTypeDataError: '',
            };
        case 'FIND_PRODUCT_PAGE_SUCCESS':
            return {
                ...state,
                loadingProductTypeApi: false,
                findProductTypeData: action.payload,
            };
        case 'FIND_PRODUCT_PAGE_FAILURE':
            return {
                ...state,
                loadingProductTypeApi: false,
                findProductTypeDataError: action.payload,
            };
        //product-type//

        //shipment-type//
        case 'FIND_SHIPMENT_PAGE_REQUEST':
            return {
                ...state,
                loadingShipmentTypeApi: true,
                findShipmentTypeData: "",
                findShipmentTypeDataError: '',
            };
        case 'FIND_SHIPMENT_PAGE_SUCCESS':
            return {
                ...state,
                loadingShipmentTypeApi: false,
                findShipmentTypeData: action.payload,
            };
        case 'FIND_SHIPMENT_PAGE_FAILURE':
            return {
                ...state,
                loadingShipmentTypeApi: false,
                findShipmentTypeDataError: action.payload,
            };
        //shipment-type//

        //shipment-mode//
        case 'FIND_SHIPMENTMODE_PAGE_REQUEST':
            return {
                ...state,
                loadingShipmentModeApi: true,
                findShipmentModeData: "",
                findShipmentModeDataError: '',
            };
        case 'FIND_SHIPMENTMODE_PAGE_SUCCESS':
            return {
                ...state,
                loadingShipmentModeApi: false,
                findShipmentModeData: action.payload,
            };
        case 'FIND_SHIPMENTMODE_PAGE_FAILURE':
            return {
                ...state,
                loadingShipmentModeApi: false,
                findShipmentModeDataError: action.payload,
            };
        //shipment-mode//

        //shipment-via//
        case 'FIND_SHIPMENTVIA_PAGE_REQUEST':
            return {
                ...state,
                loadingShipmentViaApi: true,
                findShipmentViaData: "",
                findShipmentViaDataError: '',
            };
        case 'FIND_SHIPMENTVIA_PAGE_SUCCESS':
            return {
                ...state,
                loadingShipmentViaApi: false,
                findShipmentViaData: action.payload,
            };
        case 'FIND_SHIPMENTVIA_PAGE_FAILURE':
            return {
                ...state,
                loadingShipmentViaApi: false,
                findShipmentViaDataError: action.payload,
            };
        //shipment-via//

        //CARGO TYPE//
        case 'FIND_CARGO_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingCargoTypeApi: true,
                findCargoTypeData: "",
                findCargoTypeDataError: '',
            };
        case 'FIND_CARGO_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingCargoTypeApi: false,
                findCargoTypeData: action.payload,
            };
        case 'FIND_CARGO_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingCargoTypeApi: false,
                findCargoTypeDataError: action.payload,
            };
        //CARGO TYPE//

        //DEPARTMENT TYPE//
        case 'FIND_DEPARTMENT_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingDepartmentTypeApi: true,
                findDepartmentTypeData: "",
                findDepartmentTypeDataError: '',
            };
        case 'FIND_DEPARTMENT_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingDepartmentTypeApi: false,
                findDepartmentTypeData: action.payload,
            };
        case 'FIND_DEPARTMENT_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingDepartmentTypeApi: false,
                findDepartmentTypeDataError: action.payload,
            };
        //DEPARTMENT TYPE//

        //ID PROOF//
        case 'FIND_ID_PROOF_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingIdProofTypeApi: true,
                findIdProofTypeData: "",
                findIdProofTypeDataError: '',
            };
        case 'FIND_ID_PROOF_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingIdProofTypeApi: false,
                findIdProofTypeData: action.payload,
            };
        case 'FIND_ID_PROOF_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingIdProofTypeApi: false,
                findIdProofTypeDataError: action.payload,
            };
        //ID PROOF//

        //PACKAGE//
        case 'FIND_PACKAGE_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingPackageTypeApi: true,
                findPackageTypeData: "",
                findPackageTypeDataError: '',
            };
        case 'FIND_PACKAGE_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingPackageTypeApi: false,
                findPackageTypeData: action.payload,
            };
        case 'FIND_PACKAGE_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingPackageTypeApi: false,
                findPackageTypeDataError: action.payload,
            };
        //PACKAGE//


        //gender//
        case 'FIND_GENDER_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingGenderTypeApi: true,
                findGenderTypeData: "",
                findGenderTypeDataError: '',
            };
        case 'FIND_GENDER_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingGenderTypeApi: false,
                findGenderTypeData: action.payload,
            };
        case 'FIND_GENDER_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingGenderTypeApi: false,
                findGenderTypeDataError: action.payload,
            };
        //gender//

        //DESIGNATION//
        case 'FIND_DESIGNATION_TYPE_PAGE_REQUEST':
            return {
                ...state,
                loadingDesignationTypeApi: true,
                findDesignationTypeData: "",
                findDesignationTypeDataError: '',
            };
        case 'FIND_DESIGNATION_TYPE_PAGE_SUCCESS':
            return {
                ...state,
                loadingDesignationTypeApi: false,
                findDesignationTypeData: action.payload,
            };
        case 'FIND_DESIGNATION_TYPE_PAGE_FAILURE':
            return {
                ...state,
                loadingDesignationTypeApi: false,
                findDesignationTypeDataError: action.payload,
            };
        //DESIGNATION//

        //WeightUnit//
        case 'FIND_WEIGHT_UNIT_PAGE_REQUEST':
            return {
                ...state,
                loadingWeightUnitTypeApi: true,
                findWeightUnitTypeData: "",
                findWeightUnitTypeDataError: '',
            };
        case 'FIND_WEIGHT_UNIT_PAGE_SUCCESS':
            return {
                ...state,
                loadingWeightUnitTypeApi: false,
                findWeightUnitTypeData: action.payload,
            };
        case 'FIND_WEIGHT_UNIT_PAGE_FAILURE':
            return {
                ...state,
                loadingWeightUnitTypeApi: false,
                findWeightUnitTypeDataError: action.payload,
            };
        //WeightUnit//

        //RequiredService//
        case 'FIND_REQUIRED_SERVICE_PAGE_REQUEST':
            return {
                ...state,
                loadingRequiredServiceTypeApi: true,
                findRequiredServiceTypeData: "",
                findRequiredServiceTypeDataError: '',
            };
        case 'FIND_REQUIRED_SERVICE_PAGE_SUCCESS':
            return {
                ...state,
                loadingRequiredServiceTypeApi: false,
                findRequiredServiceTypeData: action.payload,
            };
        case 'FIND_REQUIRED_SERVICE_PAGE_FAILURE':
            return {
                ...state,
                loadingRequiredServiceTypeApi: false,
                findRequiredServiceTypeDataError: action.payload,
            };
        //RequiredService//

        //view rate//
        case 'FIND_VIEW_RATE_REQUEST':
            return {
                ...state,
                loadingViewRate: true,
                viewRateData: "",
                viewRateDataError: '',
            };
        case 'FIND_VIEW_RATE_SUCCESS':
            return {
                ...state,
                loadingViewRate: false,
                viewRateData: action.payload,
            };
        case 'FIND_VIEW_RATE_FAILURE':
            return {
                ...state,
                loadingViewRate: false,
                viewRateDataError: action.payload,
            };
        //view rate//
        //download quotation//
        case 'FIND_DOWNLOAD_QUOTATION_REQUEST':
            return {
                ...state,
                loadingDownloadQuotation: true,
                DownloadQuotationData: "",
                DownloadQuotationDataError: '',
            };
        case 'FIND_DOWNLOAD_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingDownloadQuotation: false,
                DownloadQuotationData: action.payload,
            };
        case 'FIND_DOWNLOAD_QUOTATION_FAILURE':
            return {
                ...state,
                loadingDownloadQuotation: false,
                DownloadQuotationDataError: action.payload,
            };
        //download quotation//

        //profile page//
        case 'FIND_PROFILE_PAGE_REQUEST':
            return {
                ...state,
                loadingProfile: true,
                ProfileData: "",
                ProfileDataError: '',
            };
        case 'FIND_PROFILE_PAGE_SUCCESS':
            return {
                ...state,
                loadingProfile: false,
                ProfileData: action.payload,
            };
        case 'FIND_PROFILE_PAGE_FAILURE':
            return {
                ...state,
                loadingProfile: false,
                ProfileDataError: action.payload,
            };
        //profile page//


        //origin country//
        case 'FIND_ORIGIN_COUNTRY_REQUEST':
            return {
                ...state,
                loadingOriginCountry: true,
                originCountryData: "",
                originCountryDataError: '',
            };
        case 'FIND_ORIGIN_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingOriginCountry: false,
                originCountryData: action.payload,
            };
        case 'FIND_ORIGIN_COUNTRY_FAILURE':
            return {
                ...state,
                loadingOriginCountry: false,
                originCountryDataError: action.payload,
            };
        //origin country//

        //origin state//
        case 'FIND_ORIGIN_STATE_REQUEST':
            return {
                ...state,
                loadingOriginState: true,
                originStateData: "",
                originStateDataError: '',
            };
        case 'FIND_ORIGIN_STATE_SUCCESS':
            return {
                ...state,
                loadingOriginState: false,
                originStateData: action.payload,
            };
        case 'FIND_ORIGIN_STATE_FAILURE':
            return {
                ...state,
                loadingOriginState: false,
                originStateDataError: action.payload,
            };
        //origin state//

        //origin city//
        case 'FIND_ORIGIN_CITY_REQUEST':
            return {
                ...state,
                loadingOriginCity: true,
                originCityData: "",
                originCityDataError: '',
            };
        case 'FIND_ORIGIN_CITY_SUCCESS':
            return {
                ...state,
                loadingOriginCity: false,
                originCityData: action.payload,
            };
        case 'FIND_ORIGIN_CITY_FAILURE':
            return {
                ...state,
                loadingOriginCity: false,
                originCityDataError: action.payload,
            };
        //origin city//

        //destination country//
        case 'FIND_DESTINATION_COUNTRY_REQUEST':
            return {
                ...state,
                loadingDestinationCountry: true,
                destinationCountryData: [],
                destinationCountryDataError: '',
            };
        case 'FIND_DESTINATION_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingDestinationCountry: false,
                destinationCountryData: action.payload,
            };
        case 'FIND_DESTINATION_COUNTRY_FAILURE':
            return {
                ...state,
                loadingDestinationCountry: false,
                destinationCountryDataError: action.payload,
            };
        //destination country//

        //destination state//
        case 'FIND_DESTINATION_STATE_REQUEST':
            return {
                ...state,
                loadingDestinationState: true,
                destinationStateData: "",
                destinationStateDataError: '',
            };
        case 'FIND_DESTINATION_STATE_SUCCESS':
            return {
                ...state,
                loadingDestinationState: false,
                destinationStateData: action.payload,
            };
        case 'FIND_DESTINATION_STATE_FAILURE':
            return {
                ...state,
                loadingDestinationState: false,
                destinationStateDataError: action.payload,
            };
        //destination state//

        //destination city//
        case 'FIND_DESTINATION_CITY_REQUEST':
            return {
                ...state,
                loadingDestinationCity: true,
                destinationCityData: "",
                destinationCityDataError: '',
            };
        case 'FIND_DESTINATION_CITY_SUCCESS':
            return {
                ...state,
                loadingDestinationCity: false,
                destinationCityData: action.payload,
            };
        case 'FIND_DESTINATION_CITY_FAILURE':
            return {
                ...state,
                loadingDestinationCity: false,
                destinationCityDataError: action.payload,
            };
        //destination city//

        //commodity//
        case 'FIND_COMMODITY_REQUEST':
            return {
                ...state,
                loadingCommodity: true,
                commodityData: "",
                commodityDataError: '',
            };
        case 'FIND_COMMODITY_SUCCESS':
            return {
                ...state,
                loadingCommodity: false,
                commodityData: action.payload,
            };
        case 'FIND_COMMODITY_FAILURE':
            return {
                ...state,
                loadingCommodity: false,
                commodityDataError: action.payload,
            };
        //commodity//

        //incoterms//
        case 'FIND_INCOTERMS_REQUEST':
            return {
                ...state,
                loadingIncoterms: true,
                incotermsData: "",
                incotermsDataError: '',
            };
        case 'FIND_INCOTERMS_SUCCESS':
            return {
                ...state,
                loadingIncoterms: false,
                incotermsData: action.payload,
            };
        case 'FIND_INCOTERMS_FAILURE':
            return {
                ...state,
                loadingIncoterms: false,
                incotermsDataError: action.payload,
            };
        //incoterms//

        //chargehead//
        case 'FIND_CHARGEHEAD_REQUEST':
            return {
                ...state,
                loadingChargehead: true,
                chargeheadData: "",
                chargeheadDataError: '',
            };
        case 'FIND_CHARGEHEAD_SUCCESS':
            return {
                ...state,
                loadingChargehead: false,
                chargeheadData: action.payload,
            };
        case 'FIND_CHARGEHEAD_FAILURE':
            return {
                ...state,
                loadingChargehead: false,
                chargeheadDataError: action.payload,
            };
        //chargehead//

        //chargehead//
        case 'FIND_CHARGEHEAD_BY_SERVICE_TYPE_REQUEST':
            return {
                ...state,
                loadingChargeheadByService: true,
                ChargeheadByServiceData: "",
                ChargeheadByServiceDataError: '',
            };
        case 'FIND_CHARGEHEAD_BY_SERVICE_TYPE_SUCCESS':
            return {
                ...state,
                loadingChargeheadByService: false,
                ChargeheadByServiceData: action.payload,
            };
        case 'FIND_CHARGEHEAD_BY_SERVICE_TYPE_FAILURE':
            return {
                ...state,
                loadingChargeheadByService: false,
                ChargeheadByServiceDataError: action.payload,
            };
        //chargehead//


        //additionals//
        case 'FIND_ADDITIONALS_REQUEST':
            return {
                ...state,
                loadingAdditionals: true,
                additionalsData: "",
                additionalsDataError: '',
            };
        case 'FIND_ADDITIONALS_SUCCESS':
            return {
                ...state,
                loadingAdditionals: false,
                additionalsData: action.payload,
            };
        case 'FIND_ADDITIONALS_FAILURE':
            return {
                ...state,
                loadingAdditionals: false,
                additionalsDataError: action.payload,
            };
        //additionals//

        //currency//
        case 'FIND_CURRENCY_REQUEST':
            return {
                ...state,
                loadingCurrency: true,
                currencyData: "",
                currencyDataError: '',
            };
        case 'FIND_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingCurrency: false,
                currencyData: action.payload,
            };
        case 'FIND_CURRENCY_FAILURE':
            return {
                ...state,
                loadingCurrency: false,
                currencyDataError: action.payload,
            };
        //currency//

        //ExpenseType//
        case 'FIND_EXPENSE_TYPE_REQUEST':
            return {
                ...state,
                loadingExpenseType: true,
                ExpenseTypeData: "",
                ExpenseTypeDataError: '',
            };
        case 'FIND_EXPENSE_TYPE_SUCCESS':
            return {
                ...state,
                loadingExpenseType: false,
                ExpenseTypeData: action.payload,
            };
        case 'FIND_EXPENSE_TYPE_FAILURE':
            return {
                ...state,
                loadingExpenseType: false,
                ExpenseTypeDataError: action.payload,
            };
        //ExpenseType//


        //containertype//
        case 'FIND_CONTAINERTYPE_REQUEST':
            return {
                ...state,
                loadingContainertype: true,
                containertypeData: "",
                containertypeDataError: '',
            };
        case 'FIND_CONTAINERTYPE_SUCCESS':
            return {
                ...state,
                loadingContainertype: false,
                containertypeData: action.payload,
            };
        case 'FIND_CONTAINERTYPE_FAILURE':
            return {
                ...state,
                loadingContainertype: false,
                containertypeDataError: action.payload,
            };
        //containertype//


        //containersize//
        case 'FIND_CONTAINERSIZE_REQUEST':
            return {
                ...state,
                loadingContainersize: true,
                containersizeData: "",
                containersizeDataError: '',
            };
        case 'FIND_CONTAINERSIZE_SUCCESS':
            return {
                ...state,
                loadingContainersize: false,
                containersizeData: action.payload,
            };
        case 'FIND_CONTAINERSIZE_FAILURE':
            return {
                ...state,
                loadingContainersize: false,
                containersizeDataError: action.payload,
            };
        //containersize//


        //list kyc doc//
        case 'FIND_KYC_DOC_REQUEST':
            return {
                ...state,
                loadingKycDocApi: true,
                kycDocData: "",
                kycDocDataError: '',
            };
        case 'FIND_KYC_DOC_SUCCESS':
            return {
                ...state,
                loadingKycDocApi: false,
                kycDocData: action.payload,
            };
        case 'FIND_KYC_DOC_FAILURE':
            return {
                ...state,
                loadingKycDocApi: false,
                kycDocDataError: action.payload,
            };
        //list kyc doc//

        //view kyc doc//
        case 'FIND_KYC_DOC_VIEW_REQUEST':
            return {
                ...state,
                loadingKycDocViewApi: true,
                kycDocViewData: "",
                kycDocViewDataError: '',
            };
        case 'FIND_KYC_DOC_VIEW_SUCCESS':
            return {
                ...state,
                loadingKycDocViewApi: false,
                kycDocViewData: action.payload,
            };
        case 'FIND_KYC_DOC_VIEW_FAILURE':
            return {
                ...state,
                loadingKycDocViewApi: false,
                kycDocViewDataError: action.payload,
            };
        //view kyc doc//

        //country -> masters lists//

        case 'FIND_MASTER_COUNTRIES_REQUEST':
            return {
                ...state,
                loadingMasterCountry: true,
                MasterCountry: [],
                MasterCountryError: '',
                MasterCountryCurrentPage: 0,
                MasterCountryTotalPage: 0,
                MasterCountryTotalData: 0,
            };
        case 'FIND_MASTER_COUNTRIES_SUCCESS':
            return {
                ...state,
                loadingMasterCountry: false,
                MasterCountry: action.payload.data,
                MasterCountryCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCountryTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCountryTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_COUNTRIES_FAILURE':
            return {
                ...state,
                loadingMasterCountry: false,
                MasterCountryError: '',
                MasterCountryCurrentPage: 1,
                MasterCountryTotalPage: 0,
                MasterCountryTotalData: 0,
            };
        //country -> masters lists//

        //country -> masters view//
        case 'FIND_MASTER_COUNTRY_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterCountryDetail: true,
                MasterCountryDetail: {},
                MasterCountryDetailError: '',
            };
        case 'FIND_MASTER_COUNTRY_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterCountryDetail: false,
                MasterCountryDetail: action.payload,
            };
        case 'FIND_MASTER_COUNTRY_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterCountryDetail: false,
                MasterCountryDetailError: '',
            };
        //country -> masters view//

        //states -> masters lists//
        case 'FIND_MASTER_STATES_REQUEST':
            return {
                ...state,
                loadingMasterState: true,
                MasterState: [],
                MasterStateError: '',
                MasterStateCurrentPage: 0,
                MasterStateTotalPage: 0,
                MasterStateTotalData: 0,
            };
        case 'FIND_MASTER_STATES_SUCCESS':
            return {
                ...state,
                loadingMasterState: false,
                MasterState: action.payload.data,
                MasterStateCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterStateTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterStateTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_STATES_FAILURE':
            return {
                ...state,
                loadingMasterState: false,
                MasterStateError: '',
                MasterStateCurrentPage: 1,
                MasterStateTotalPage: 0,
                MasterStateTotalData: 0,
            };
        //states -> masters lists//

        //states -> masters view//
        case 'FIND_MASTER_STATE_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterStateDetail: true,
                MasterStateDetail: {},
                MasterStateDetailError: '',
            };
        case 'FIND_MASTER_STATE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterStateDetail: false,
                MasterStateDetail: action.payload,
            };
        case 'FIND_MASTER_STATE_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterStateDetail: false,
                MasterStateDetailError: '',
            };
        //states -> masters view//


        //states by cities -> masters view//
        case 'FIND_MASTER_STATE_BY_COUNTRY_REQUEST':
            return {
                ...state,
                loadingMasterStateByCountryList: true,
                MasterStateByCountryList: [],
                MasterStateByCountryListError: '',
            };
        case 'FIND_MASTER_STATE_BY_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingMasterStateByCountryList: false,
                MasterStateByCountryList: action.payload,
            };
        case 'FIND_MASTER_STATE_BY_COUNTRY_FAILURE':
            return {
                ...state,
                loadingMasterStateByCountryList: false,
                MasterStateByCountryListError: '',
            };
        //states by cities -> masters view//

        //states by cities -> masters view//  --> IATA Agent GST country state
        case 'FIND_MASTER_STATE_BY_GST_COUNTRY_REQUEST':
            return {
                ...state,
                loadingMasterStateByGSTCountryList: true,
                MasterStateByGSTCountryList: [],
                MasterStateByGSTCountryListError: '',
            };
        case 'FIND_MASTER_STATE_BY_GST_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingMasterStateByGSTCountryList: false,
                MasterStateByGSTCountryList: action.payload,
            };
        case 'FIND_MASTER_STATE_BY_GST_COUNTRY_FAILURE':
            return {
                ...state,
                loadingMasterStateByGSTCountryList: false,
                MasterStateByGSTCountryListError: '',
            };
        //states by cities -> masters view//

        //states by cities -> masters view//
        case 'FIND_MASTER_CITY_BY_STATE_REQUEST':
            return {
                ...state,
                loadingMasterCityByStateList: true,
                MasterCityByStateList: [],
                MasterCityByStateListError: '',
            };
        case 'FIND_MASTER_CITY_BY_STATE_SUCCESS':
            return {
                ...state,
                loadingMasterCityByStateList: false,
                MasterCityByStateList: action.payload,
            };
        case 'FIND_MASTER_CITY_BY_STATE_FAILURE':
            return {
                ...state,
                loadingMasterCityByStateList: false,
                MasterCityByStateListError: '',
            };
        //states by cities -> masters view//

        //cities -> masters lists//
        case 'FIND_MASTER_CITIES_REQUEST':
            return {
                ...state,
                loadingMasterCity: true,
                MasterCity: [],
                MasterCityError: '',
                MasterCityCurrentPage: 0,
                MasterCityTotalPage: 0,
                MasterCityTotalData: 0,
            };
        case 'FIND_MASTER_CITIES_SUCCESS':
            return {
                ...state,
                loadingMasterCity: false,
                MasterCity: action.payload.data,
                MasterCityCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCityTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCityTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_CITIES_FAILURE':
            return {
                ...state,
                loadingMasterCity: false,
                MasterCityError: '',
                MasterCityCurrentPage: 1,
                MasterCityTotalPage: 0,
                MasterCityTotalData: 0,
            };
        //cities -> masters lists//

        //cities -> masters view//
        case 'FIND_MASTER_CITY_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterCityDetail: true,
                MasterCityDetail: {},
                MasterCityDetailError: '',
            };
        case 'FIND_MASTER_CITY_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterCityDetail: false,
                MasterCityDetail: action.payload,
            };
        case 'FIND_MASTER_CITY_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterCityDetail: false,
                MasterCityDetailError: '',
            };
        //cities -> masters view//


        //airport -> masters lists//
        case 'FIND_MASTER_AIRPORTS_REQUEST':
            return {
                ...state,
                loadingMasterAirport: true,
                MasterAirport: [],
                MasterAirportError: '',
                MasterAirportCurrentPage: 0,
                MasterAirportTotalPage: 0,
                MasterAirportTotalData: 0,
            };
        case 'FIND_MASTER_AIRPORTS_SUCCESS':
            return {
                ...state,
                loadingMasterAirport: false,
                MasterAirport: action.payload.data,
                MasterAirportCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAirportTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAirportTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_AIRPORTS_FAILURE':
            return {
                ...state,
                loadingMasterAirport: false,
                MasterAirportError: '',
                MasterAirportCurrentPage: 1,
                MasterAirportTotalPage: 0,
                MasterAirportTotalData: 0,
            };
        //airport -> masters lists//

        //airport -> masters view//
        case 'FIND_MASTER_AIRPORT_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterAirportDetail: true,
                MasterAirportDetail: {},
                MasterAirportDetailError: '',
            };
        case 'FIND_MASTER_AIRPORT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterAirportDetail: false,
                MasterAirportDetail: action.payload,
            };
        case 'FIND_MASTER_AIRPORT_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterAirportDetail: false,
                MasterAirportDetailError: '',
            };
        //airport -> masters view//

        //seaport -> masters lists//
        case 'FIND_MASTER_SEAPORTS_REQUEST':
            return {
                ...state,
                loadingMasterSeaport: true,
                MasterSeaport: [],
                MasterSeaportError: '',
                MasterSeaportCurrentPage: 0,
                MasterSeaportTotalPage: 0,
                MasterSeaportTotalData: 0,
            };
        case 'FIND_MASTER_SEAPORTS_SUCCESS':
            return {
                ...state,
                loadingMasterSeaport: false,
                MasterSeaport: action.payload.data,
                MasterSeaportCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterSeaportTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterSeaportTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_SEAPORTS_FAILURE':
            return {
                ...state,
                loadingMasterSeaport: false,
                MasterSeaportError: '',
                MasterSeaportCurrentPage: 1,
                MasterSeaportTotalPage: 0,
                MasterSeaportTotalData: 0,
            };
        //seaport -> masters lists//

        //seaport -> masters view//
        case 'FIND_MASTER_SEAPORT_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterSeaportDetail: true,
                MasterSeaportDetail: {},
                MasterSeaportDetailError: '',
            };
        case 'FIND_MASTER_SEAPORT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterSeaportDetail: false,
                MasterSeaportDetail: action.payload,
            };
        case 'FIND_MASTER_SEAPORT_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterSeaportDetail: false,
                MasterSeaportDetailError: '',
            };
        //seaport -> masters view//

        //airline -> masters lists//
        case 'FIND_MASTER_AIRLINES_REQUEST':
            return {
                ...state,
                loadingMasterAirline: true,
                MasterAirline: [],
                MasterAirlineError: '',
                MasterAirlineCurrentPage: 0,
                MasterAirlineTotalPage: 0,
                MasterAirlineTotalData: 0,
            };
        case 'FIND_MASTER_AIRLINES_SUCCESS':
            return {
                ...state,
                loadingMasterAirline: false,
                MasterAirline: action.payload.data,
                MasterAirlineCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAirlineTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAirlineTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_AIRLINES_FAILURE':
            return {
                ...state,
                loadingMasterAirline: false,
                MasterAirlineError: '',
                MasterAirlineCurrentPage: 1,
                MasterAirlineTotalPage: 0,
                MasterAirlineTotalData: 0,
            };
        //airline -> masters lists//

        //airline -> masters view//
        case 'FIND_MASTER_AIRLINE_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterAirlineDetail: true,
                MasterAirlineDetail: {},
                MasterAirlineDetailError: '',
            };
        case 'FIND_MASTER_AIRLINE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterAirlineDetail: false,
                MasterAirlineDetail: action.payload,
            };
        case 'FIND_MASTER_AIRLINE_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterAirlineDetail: false,
                MasterAirlineDetailError: '',
            };
        //airline -> masters view//

        //shipline -> masters lists//
        case 'FIND_MASTER_SHIPLINES_REQUEST':
            return {
                ...state,
                loadingMasterShipline: true,
                MasterShipline: [],
                MasterShiplineError: '',
                MasterShiplineCurrentPage: 0,
                MasterShiplineTotalPage: 0,
                MasterShiplineTotalData: 0,
            };
        case 'FIND_MASTER_SHIPLINES_SUCCESS':
            return {
                ...state,
                loadingMasterShipline: false,
                MasterShipline: action.payload.data,
                MasterShiplineCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterShiplineTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterShiplineTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_SHIPLINES_FAILURE':
            return {
                ...state,
                loadingMasterShipline: false,
                MasterShiplineError: '',
                MasterShiplineCurrentPage: 1,
                MasterShiplineTotalPage: 0,
                MasterShiplineTotalData: 0,
            };
        //shipline -> masters lists//

        //shipline -> masters view//
        case 'FIND_MASTER_SHIPLINE_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterShiplineDetail: true,
                MasterShiplineDetail: {},
                MasterShiplineDetailError: '',
            };
        case 'FIND_MASTER_SHIPLINE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterShiplineDetail: false,
                MasterShiplineDetail: action.payload,
            };
        case 'FIND_MASTER_SHIPLINE_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterShiplineDetail: false,
                MasterShiplineDetailError: '',
            };
        //shipline -> masters view//

        //master -> view custoer details//
        case 'FIND_CUSTOMER_DETAIL_BY_USERNAME_REQUEST':
            return {
                ...state,
                loadingCustomerDetailbyUsername: true,
                CustomerDetailbyUsername: {},
                CustomerDetailbyUsernameError: '',
            };
        case 'FIND_CUSTOMER_DETAIL_BY_USERNAME_SUCCESS':
            return {
                ...state,
                loadingCustomerDetailbyUsername: false,
                CustomerDetailbyUsername: action.payload,
            };
        case 'FIND_CUSTOMER_DETAIL_BY_USERNAME_FAILURE':
            return {
                ...state,
                loadingCustomerDetailbyUsername: false,
                CustomerDetailbyUsernameError: '',
            };
        //master -> view custoer details//



        //iata agent -> get//
        case 'FIND_MASTER_IATA_AGENT_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgent: true,
                MasterIATAAgent: [],
                MasterIATAAgentError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgent: false,
                MasterIATAAgent: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgent: false,
                MasterIATAAgent: [],
                MasterIATAAgentError: action.payload,
            };
        //iata agent -> get//


        //iata agent -> masters lists//
        case 'FIND_MASTER_IATA_AGENT_LIST_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentList: true,
                MasterIATAAgentList: [],
                MasterIATAAgentListError: '',
                MasterIATAAgentListCurrentPage: 0,
                MasterIATAAgentListTotalPage: 0,
                MasterIATAAgentListTotalData: 0,
            };
        case 'FIND_MASTER_IATA_AGENT_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentList: false,
                MasterIATAAgentList: action.payload.data,
                MasterIATAAgentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterIATAAgentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterIATAAgentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_IATA_AGENT_LIST_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentList: false,
                MasterIATAAgentList: [],
                MasterIATAAgentListError: '',
                MasterIATAAgentListCurrentPage: 1,
                MasterIATAAgentListTotalPage: 0,
                MasterIATAAgentListTotalData: 0,
            };
        //iata agent -> masters lists//

        //iata agent detail//
        case 'FIND_MASTER_IATA_AGENT_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentDetail: true,
                MasterIATAAgentDetail: null,
                MasterIATAAgentDetailError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentDetail: false,
                MasterIATAAgentDetail: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentDetail: false,
                MasterIATAAgentDetail: null,
                MasterIATAAgentDetailError: action.payload,
            };
        //iata agent detail//


        //iata agent -> address list//
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_LIST_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentAddressList: true,
                MasterIATAAgentAddressList: [],
                MasterIATAAgentAddressListError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentAddressList: false,
                MasterIATAAgentAddressList: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_LIST_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentAddressList: false,
                MasterIATAAgentAddressList: [],
                MasterIATAAgentAddressListError: action.payload,
            };
        //iata agent -> address list//

        //iata agent -> address detail//
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentAddressDetail: true,
                MasterIATAAgentAddressDetail: null,
                MasterIATAAgentAddressDetailError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentAddressDetail: false,
                MasterIATAAgentAddressDetail: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentAddressDetail: false,
                MasterIATAAgentAddressDetail: null,
                MasterIATAAgentAddressDetailError: action.payload,
            };
        //iata agent -> address detail//

        //iata agent -> sales list//
        case 'FIND_MASTER_IATA_AGENT_SALES_LIST_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentSalesList: true,
                MasterIATAAgentSalesList: [],
                MasterIATAAgentSalesListError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_SALES_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentSalesList: false,
                MasterIATAAgentSalesList: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_SALES_LIST_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentSalesList: false,
                MasterIATAAgentSalesList: [],
                MasterIATAAgentSalesListError: action.payload,
            };
        //iata agent -> sales list//

        //iata agent -> sales detail//
        case 'FIND_MASTER_IATA_AGENT_SALES_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentSalesDetail: true,
                MasterIATAAgentSalesDetail: null,
                MasterIATAAgentSalesDetailError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_SALES_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentSalesDetail: false,
                MasterIATAAgentSalesDetail: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_SALES_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentSalesDetail: false,
                MasterIATAAgentSalesDetail: null,
                MasterIATAAgentSalesDetailError: action.payload,
            };
        //iata agent -> sales detail//

        //iata agent -> customer list//
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentCustomerList: true,
                MasterIATAAgentCustomerList: [],
                MasterIATAAgentCustomerListError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentCustomerList: false,
                MasterIATAAgentCustomerList: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentCustomerList: false,
                MasterIATAAgentCustomerList: [],
                MasterIATAAgentCustomerListError: action.payload,
            };
        //iata agent -> customer list//

        //iata agent -> customer detail//
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentCustomerDetail: true,
                MasterIATAAgentCustomerDetail: null,
                MasterIATAAgentCustomerDetailError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentCustomerDetail: false,
                MasterIATAAgentCustomerDetail: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentCustomerDetail: false,
                MasterIATAAgentCustomerDetail: null,
                MasterIATAAgentCustomerDetailError: action.payload,
            };
        //iata agent -> customer detail//

        //iata agent -> contact list//
        case 'FIND_MASTER_IATA_AGENT_CONTACT_LIST_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentContactList: true,
                MasterIATAAgentContactList: [],
                MasterIATAAgentContactListError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_CONTACT_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentContactList: false,
                MasterIATAAgentContactList: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_CONTACT_LIST_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentContactList: false,
                MasterIATAAgentContactList: [],
                MasterIATAAgentContactListError: action.payload,
            };
        //iata agent -> contact list//

        //iata agent -> contact detail//
        case 'FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterIATAAgentContactDetail: true,
                MasterIATAAgentContactDetail: null,
                MasterIATAAgentContactDetailError: '',
            };
        case 'FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterIATAAgentContactDetail: false,
                MasterIATAAgentContactDetail: action.payload,
            };
        case 'FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterIATAAgentContactDetail: false,
                MasterIATAAgentContactDetail: null,
                MasterIATAAgentContactDetailError: action.payload,
            };
        //iata agent -> contact detail//

        //airline -> address list//
        case 'FIND_MASTER_AIRLINE_ADDRESS_LIST_REQUEST':
            return {
                ...state,
                loadingMasterAirlineAddressList: true,
                MasterAirlineAddressList: [],
                MasterAirlineAddressListError: '',
            };
        case 'FIND_MASTER_AIRLINE_ADDRESS_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterAirlineAddressList: false,
                MasterAirlineAddressList: action.payload,
            };
        case 'FIND_MASTER_AIRLINE_ADDRESS_LIST_FAILURE':
            return {
                ...state,
                loadingMasterAirlineAddressList: false,
                MasterAirlineAddressList: [],
                MasterAirlineAddressListError: action.payload,
            };
        //airline -> address list//

        //airline -> address detail//
        case 'FIND_MASTER_AIRLINE_ADDRESS_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterAirlineAddressDetail: true,
                MasterAirlineAddressDetail: null,
                MasterAirlineAddressDetailError: '',
            };
        case 'FIND_MASTER_AIRLINE_ADDRESS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterAirlineAddressDetail: false,
                MasterAirlineAddressDetail: action.payload,
            };
        case 'FIND_MASTER_AIRLINE_ADDRESS_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterAirlineAddressDetail: false,
                MasterAirlineAddressDetail: null,
                MasterAirlineAddressDetailError: action.payload,
            };
        //airline -> address detail//

        //airline -> list//
        case 'FIND_MASTER_AIRLINE_LIST_REQUEST':
            return {
                ...state,
                loadingMasterAirlineList: true,
                MasterAirlineList: [],
                MasterAirlineListError: '',
            };
        case 'FIND_MASTER_AIRLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingMasterAirlineList: false,
                MasterAirlineList: action.payload,
            };
        case 'FIND_MASTER_AIRLINE_LIST_FAILURE':
            return {
                ...state,
                loadingMasterAirlineList: false,
                MasterAirlineList: [],
                MasterAirlineListError: action.payload,
            };
        //airline -> list//

        //airline -> address list//
        case 'FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_REQUEST':
            return {
                ...state,
                loadingAirlineAddressByAirlineList: true,
                AirlineAddressByAirlineList: [],
                AirlineAddressByAirlineListError: '',
            };
        case 'FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingAirlineAddressByAirlineList: false,
                AirlineAddressByAirlineList: action.payload,
            };
        case 'FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_FAILURE':
            return {
                ...state,
                loadingAirlineAddressByAirlineList: false,
                AirlineAddressByAirlineList: [],
                AirlineAddressByAirlineListError: action.payload,
            };
        //airline -> address list//

        //iata agent -> list//
        case 'FIND_IATA_AGENT_LIST_REQUEST':
            return {
                ...state,
                loadingIATAAgentList: true,
                IATAAgentList: [],
                IATAAgentListError: '',
            };
        case 'FIND_IATA_AGENT_LIST_SUCCESS':
            return {
                ...state,
                loadingIATAAgentList: false,
                IATAAgentList: action.payload,
            };
        case 'FIND_IATA_AGENT_LIST_FAILURE':
            return {
                ...state,
                loadingIATAAgentList: false,
                IATAAgentList: [],
                IATAAgentListError: action.payload,
            };
        //iata agent -> list//

        //iata agent -> address list//
        case 'FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_REQUEST':
            return {
                ...state,
                loadingIATAAgentAddressByIATAAgentList: true,
                IATAAgentAddressByIATAAgentList: [],
                IATAAgentAddressByIATAAgentListError: '',
            };
        case 'FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_SUCCESS':
            return {
                ...state,
                loadingIATAAgentAddressByIATAAgentList: false,
                IATAAgentAddressByIATAAgentList: action.payload,
            };
        case 'FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_FAILURE':
            return {
                ...state,
                loadingIATAAgentAddressByIATAAgentList: false,
                IATAAgentAddressByIATAAgentList: [],
                IATAAgentAddressByIATAAgentListError: action.payload,
            };
        //iata agent -> address list//

        //rate class list//
        case 'FIND_MASTER_RATE_CLASS_REQUEST':
            return {
                ...state,
                loadingMasterRateclassList: true,
                MasterRateclassList: [],
                MasterRateclassListError: '',
                MasterRateclassListCurrentPage: 0,
                MasterRateclassListTotalPage: 0,
                MasterRateclassListTotalData: 0,
            };
        case 'FIND_MASTER_RATE_CLASS_SUCCESS':
            return {
                ...state,
                loadingMasterRateclassList: false,
                MasterRateclassList: action.payload.data,
                MasterRateclassListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterRateclassListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterRateclassListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_RATE_CLASS_FAILURE':
            return {
                ...state,
                loadingMasterRateclassList: false,
                MasterRateclassListError: '',
                MasterRateclassListCurrentPage: 1,
                MasterRateclassListTotalPage: 0,
                MasterRateclassListTotalData: 0,
            };

        case 'FIND_MASTER_RATE_CLASS_DETAIL_REQUEST':
            return {
                ...state,
                loadingMasterRateclassDetail: true,
                MasterRateclassDetail: {},
                MasterRateclassDetailError: '',
            };
        case 'FIND_MASTER_RATE_CLASS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingMasterRateclassDetail: false,
                MasterRateclassDetail: action.payload,
            };
        case 'FIND_MASTER_RATE_CLASS_DETAIL_FAILURE':
            return {
                ...state,
                loadingMasterRateclassDetail: false,
                MasterRateclassDetailError: '',
            };

        case 'FIND_RATE_CLASS_REQUEST':
            return {
                ...state,
                loadingRateclassList: true,
                RateclassList: [],
                RateclassListError: '',
            };
        case 'FIND_RATE_CLASS_SUCCESS':
            return {
                ...state,
                loadingRateclassList: false,
                RateclassList: action.payload,
            };
        case 'FIND_RATE_CLASS_FAILURE':
            return {
                ...state,
                loadingRateclassList: false,
                RateclassListError: action.payload,
            };
        //rate class list//


        case 'FIND_SPECIALIZATION_LIST_REQUEST':
            return {
                ...state,
                loadingSpecializationApi: true,
                findSpecializationData: [],
                findSpecializationDataError: '',
            };
        case 'FIND_SPECIALIZATION_LIST_SUCCESS':
            return {
                ...state,
                loadingSpecializationApi: false,
                findSpecializationData: action.payload,
            };
        case 'FIND_SPECIALIZATION_LIST_FAILURE':
            return {
                ...state,
                loadingSpecializationApi: false,
                findSpecializationDataError: action.payload,
            };


        case 'FIND_SPECIALIZATION_ACTIVE_LIST_REQUEST':
            return {
                ...state,
                loadingSpecializationActiveApi: true,
                findSpecializationActiveData: [],
                findSpecializationActiveDataError: '',
            };
        case 'FIND_SPECIALIZATION_ACTIVE_LIST_SUCCESS':
            return {
                ...state,
                loadingSpecializationActiveApi: false,
                findSpecializationActiveData: action.payload,
            };
        case 'FIND_SPECIALIZATION_ACTIVE_LIST_FAILURE':
            return {
                ...state,
                loadingSpecializationActiveApi: false,
                findSpecializationActiveDataError: action.payload,
            };
        case 'FIND_LICENSE_TYPE_ACTIVE_LIST_REQUEST':
            return {
                ...state,
                loadingLicenseTypeActiveApi: true,
                findLicenseTypeActiveData: [],
                findLicenseTypeActiveDataError: '',
            };
        case 'FIND_LICENSE_TYPE_ACTIVE_LIST_SUCCESS':
            return {
                ...state,
                loadingLicenseTypeActiveApi: false,
                findLicenseTypeActiveData: action.payload,
            };
        case 'FIND_LICENSE_TYPE_ACTIVE_LIST_FAILURE':
            return {
                ...state,
                loadingLicenseTypeActiveApi: false,
                findLicenseTypeActiveDataError: action.payload,
            };
        case 'FIND_VEHICLE_TYPE_ACTIVE_LIST_REQUEST':
            return {
                ...state,
                loadingVehicleTypeActiveApi: true,
                findVehicleTypeActiveData: [],
                findVehicleTypeActiveDataError: '',
            };
        case 'FIND_VEHICLE_TYPE_ACTIVE_LIST_SUCCESS':
            return {
                ...state,
                loadingVehicleTypeActiveApi: false,
                findVehicleTypeActiveData: action.payload,
            };
        case 'FIND_VEHICLE_TYPE_ACTIVE_LIST_FAILURE':
            return {
                ...state,
                loadingVehicleTypeActiveApi: false,
                findVehicleTypeActiveDataError: action.payload,
            };


        case 'FIND_LICENSE_TYPE_LIST_REQUEST':
            return {
                ...state,
                loadingLicenseTypeApi: true,
                findLicenseTypeData: [],
                findLicenseTypeDataError: '',
            };
        case 'FIND_LICENSE_TYPE_LIST_SUCCESS':
            return {
                ...state,
                loadingLicenseTypeApi: false,
                findLicenseTypeData: action.payload,
            };
        case 'FIND_LICENSE_TYPE_LIST_FAILURE':
            return {
                ...state,
                loadingLicenseTypeApi: false,
                findLicenseTypeDataError: action.payload,
            };

        case 'FIND_VEHICLE_TYPE_LIST_REQUEST':
            return {
                ...state,
                loadingVehicleTypeApi: true,
                findVehicleTypeData: [],
                findVehicleTypeDataError: '',
            };
        case 'FIND_VEHICLE_TYPE_LIST_SUCCESS':
            return {
                ...state,
                loadingVehicleTypeApi: false,
                findVehicleTypeData: action.payload,
            };
        case 'FIND_VEHICLE_TYPE_LIST_FAILURE':
            return {
                ...state,
                loadingVehicleTypeApi: false,
                findVehicleTypeDataError: action.payload,
            };


        // --------------account master-----------------
        //parent -> masters lists//

        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_REQUEST':
            return {
                ...state,
                loadingMasterAccountParentGroup: true,
                MasterAccountParentGroup: [],
                MasterAccountParentGroupError: "",
                MasterAccountParentGroupCurrentPage: 0,
                MasterAccountParentGroupTotalPage: 0,
                MasterAccountParentGroupTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_SUCCESS':
            return {
                ...state,
                loadingMasterAccountParentGroup: false,
                MasterAccountParentGroup: action.payload.data,
                MasterAccountParentGroupCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountParentGroupTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountParentGroupTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_FAILURE':
            return {
                ...state,
                loadingMasterAccountParentGroup: false,
                MasterAccountParentGroupError: '',
                MasterAccountParentGroupCurrentPage: 1,
                MasterAccountParentGroupTotalPage: 0,
                MasterAccountParentGroupTotalData: 0,
            };
        //parent -> masters lists//


        //parent -> name and id//

        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountParentGroupName: true,
                MasterAccountParentGroupName: [],
                MasterAccountParentGroupNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountParentGroupName: false,
                MasterAccountParentGroupName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountParentGroupName: false,
                MasterAccountParentGroupNameError: '',
            };
        //parent -> name and id//

        //group Type -> masters lists//
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_REQUEST':
            return {
                ...state,
                loadingMasterAccountGroupType: true,
                MasterAccountGroupType: [],
                MasterAccountGroupTypeError: "",
                MasterAccountGroupTypeCurrentPage: 0,
                MasterAccountGroupTypeTotalPage: 0,
                MasterAccountGroupTypeTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_SUCCESS':
            return {
                ...state,
                loadingMasterAccountGroupType: false,
                MasterAccountGroupType: action.payload.data,
                MasterAccountGroupTypeCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountGroupTypeTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountGroupTypeTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_FAILURE':
            return {
                ...state,
                loadingMasterAccountGroupType: false,
                MasterAccountGroupTypeError: '',
                MasterAccountGroupTypeCurrentPage: 1,
                MasterAccountGroupTypeTotalPage: 0,
                MasterAccountGroupTypeTotalData: 0,
            };
        //group type -> masters lists//

        //group Type -> id and name//
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountGroupTypeName: true,
                MasterAccountGroupTypeName: [],
                MasterAccountGroupTypeNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountGroupTypeName: false,
                MasterAccountGroupTypeName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountGroupTypeName: false,
                MasterAccountGroupTypeNameError: '',
            };
        //group type -> id and name//


        //SUB group Type -> masters lists//
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_REQUEST':
            return {
                ...state,
                loadingMasterAccountSubGroupType: true,
                MasterAccountSubGroupType: [],
                MasterAccountSubGroupTypeError: "",
                MasterAccountSubGroupTypeCurrentPage: 0,
                MasterAccountSubGroupTypeTotalPage: 0,
                MasterAccountSubGroupTypeTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_SUCCESS':
            return {
                ...state,
                loadingMasterAccountSubGroupType: false,
                MasterAccountSubGroupType: action.payload.data,
                MasterAccountSubGroupTypeCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountSubGroupTypeTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountSubGroupTypeTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_FAILURE':
            return {
                ...state,
                loadingMasterAccountSubGroupType: false,
                MasterAccountSubGroupTypeError: '',
                MasterAccountSubGroupTypeCurrentPage: 1,
                MasterAccountSubGroupTypeTotalPage: 0,
                MasterAccountSubGroupTypeTotalData: 0,
            };
        //SUB group type -> masters lists//

        //SUB group Type -> id and name lists//
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountSubGroupTypeName: true,
                MasterAccountSubGroupTypeName: [],
                MasterAccountSubGroupTypeNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountSubGroupTypeName: false,
                MasterAccountSubGroupTypeName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountSubGroupTypeName: false,
                MasterAccountSubGroupTypeErrorName: '',
            };
        //SUB group type -> id and name lists//


        // ---------------------group master------------------
        //group Type -> masters lists//
        case 'FIND_GROUP_MASTER_REQUEST':
            return {
                ...state,
                loadingGroupMaster: true,
                GroupMaster: [],
                GroupMasterError: "",
                GroupMasterCurrentPage: 0,
                GroupMasterTotalPage: 0,
                GroupMasterTotalData: 0,
            };
        case 'FIND_GROUP_MASTER_SUCCESS':
            return {
                ...state,
                loadingGroupMaster: false,
                GroupMaster: action.payload.data,
                GroupMasterCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                GroupMasterTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                GroupMasterTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_GROUP_MASTER_FAILURE':
            return {
                ...state,
                loadingGroupMaster: false,
                GroupMasterError: '',
                GroupMasterCurrentPage: 1,
                GroupMasterTotalPage: 0,
                GroupMasterTotalData: 0,
            };
        //group type -> masters lists//

        //GROUP MASTER -> id and name lists//
        case 'FIND_GROUP_MASTER_NAME_REQUEST':
            return {
                ...state,
                loadingGroupMasterName: true,
                GroupMasterName: [],
                GroupMasterNameError: "",
            };
        case 'FIND_GROUP_MASTER_NAME_SUCCESS':
            return {
                ...state,
                loadingGroupMasterName: false,
                GroupMasterName: action.payload.data,
            };
        case 'FIND_GROUP_MASTER_NAME_FAILURE':
            return {
                ...state,
                loadingGroupMasterName: false,
                GroupMasterErrorName: '',
            };
        //GROUP MASTER -> id and name lists//



        // -----------------ledger account--------------------------


        //ledger account party name -> name and id//

        case 'FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_REQUEST':
            return {
                ...state,
                loadingLedgerAccountIdAndPartyName: true,
                LedgerAccountIdAndPartyName: [],
                LedgerAccountIdAndPartyNameError: "",
            };
        case 'FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_SUCCESS':
            return {
                ...state,
                loadingLedgerAccountIdAndPartyName: false,
                LedgerAccountIdAndPartyName: action.payload.data,
            };
        case 'FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_FAILURE':
            return {
                ...state,
                loadingLedgerAccountIdAndPartyName: false,
                LedgerAccountIdAndPartyNameError: '',
            };
        //ledger account party name -> name and id//


        //ledger group type -> masters lists//

        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_REQUEST':
            return {
                ...state,
                loadingMasterAccountLedgerGroupType: true,
                MasterAccountLedgerGroupType: [],
                MasterAccountLedgerGroupTypeError: "",
                MasterAccountLedgerGroupTypeCurrentPage: 0,
                MasterAccountLedgerGroupTypeTotalPage: 0,
                MasterAccountLedgerGroupTypeTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_SUCCESS':
            return {
                ...state,
                loadingMasterAccountLedgerGroupType: false,
                MasterAccountLedgerGroupType: action.payload.data,
                MasterAccountLedgerGroupTypeCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountLedgerGroupTypeTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountLedgerGroupTypeTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_FAILURE':
            return {
                ...state,
                loadingMasterAccountLedgerGroupType: false,
                MasterAccountLedgerGroupTypeError: '',
                MasterAccountLedgerGroupTypeCurrentPage: 1,
                MasterAccountLedgerGroupTypeTotalPage: 0,
                MasterAccountLedgerGroupTypeTotalData: 0,
            };
        //ledger group type -> masters lists//


        //ledger group type -> name and id//

        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountLedgerGroupTypeName: true,
                MasterAccountLedgerGroupTypeName: [],
                MasterAccountLedgerGroupTypeNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountLedgerGroupTypeName: false,
                MasterAccountLedgerGroupTypeName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountLedgerGroupTypeName: false,
                MasterAccountLedgerGroupTypeNameError: '',
            };
        //ledger group type -> name and id//



        //tds category -> masters lists//

        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_REQUEST':
            return {
                ...state,
                loadingMasterAccountTdsCategory: true,
                MasterAccountTdsCategory: [],
                MasterAccountTdsCategoryError: "",
                MasterAccountTdsCategoryCurrentPage: 0,
                MasterAccountTdsCategoryTotalPage: 0,
                MasterAccountTdsCategoryTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_SUCCESS':
            return {
                ...state,
                loadingMasterAccountTdsCategory: false,
                MasterAccountTdsCategory: action.payload.data,
                MasterAccountTdsCategoryCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountTdsCategoryTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountTdsCategoryTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_FAILURE':
            return {
                ...state,
                loadingMasterAccountTdsCategory: false,
                MasterAccountTdsCategoryError: '',
                MasterAccountTdsCategoryCurrentPage: 1,
                MasterAccountTdsCategoryTotalPage: 0,
                MasterAccountTdsCategoryTotalData: 0,
            };
        //tds category -> masters lists//


        //tds category -> name and id//

        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountTdsCategoryeName: true,
                MasterAccountTdsCategoryName: [],
                MasterAccountTdsCategoryNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountTdsCategoryName: false,
                MasterAccountTdsCategoryName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountTdsCategoryName: false,
                MasterAccountTdsCategoryNameError: '',
            };
        //tds category -> name and id//





        //account group -> masters lists//

        case 'FIND_MASTER_ACCOUNT_GROUP_REQUEST':
            return {
                ...state,
                loadingMasterAccountGroup: true,
                MasterAccountGroup: [],
                MasterAccountGroupError: "",
                MasterAccountGroupCurrentPage: 0,
                MasterAccountGroupTotalPage: 0,
                MasterAccountGroupTotalData: 0,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_SUCCESS':
            return {
                ...state,
                loadingMasterAccountGroup: false,
                MasterAccountGroup: action.payload.data,
                MasterAccountGroupCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterAccountGroupTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterAccountGroupTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_FAILURE':
            return {
                ...state,
                loadingMasterAccountGroup: false,
                MasterAccountGroupError: '',
                MasterAccountGroupCurrentPage: 1,
                MasterAccountGroupTotalPage: 0,
                MasterAccountGroupTotalData: 0,
            };
        //account group -> masters lists//


        //account group -> name and id//

        case 'FIND_MASTER_ACCOUNT_GROUP_NAME_REQUEST':
            return {
                ...state,
                loadingMasterAccountGroupName: true,
                MasterAccountLGroupName: [],
                MasterAccountLGroupNameError: "",
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterAccountGroupName: false,
                MasterAccountGroupName: action.payload.data,
            };
        case 'FIND_MASTER_ACCOUNT_GROUP_NAME_FAILURE':
            return {
                ...state,
                loadingMasterAccountGroupName: false,
                MasterAccountGroupNameError: '',
            };
        //account group -> name and id//





        //cash book -> masters lists//

        case 'FIND_MASTER_CASH_BOOK_REQUEST':
            return {
                ...state,
                loadingMasterCashBook: true,
                MasterCashBook: [],
                MasterCashBookError: "",
                MasterCashBookCurrentPage: 0,
                MasterCashBookTotalPage: 0,
                MasterCashBookTotalData: 0,
            };
        case 'FIND_MASTER_CASH_BOOK_SUCCESS':
            return {
                ...state,
                loadingMasterCashBook: false,
                MasterCashBook: action.payload.data,
                MasterCashBookCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCashBookTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCashBookTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_CASH_BOOK_FAILURE':
            return {
                ...state,
                loadingMasterCashBook: false,
                MasterCashBookError: '',
                MasterCashBookCurrentPage: 1,
                MasterCashBookTotalPage: 0,
                MasterCashBookTotalData: 0,
            };
        //cash book -> masters lists//


        //cash book -> name and id//

        case 'FIND_MASTER_CASH_BOOK_NAME_REQUEST':
            return {
                ...state,
                loadingMasterCashBookName: true,
                MasterCashBookName: [],
                MasterCashBookNameError: "",
            };
        case 'FIND_MASTER_CASH_BOOK_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterCashBookName: false,
                MasterCashBookName: action.payload.data,
            };
        case 'FIND_MASTER_CASH_BOOK_NAME_FAILURE':
            return {
                ...state,
                loadingMasterCashBookName: false,
                MasterCashBookNameError: '',
            };
        //cash book -> name and id//



        //branch -> masters lists//

        case 'FIND_MASTER_BRANCH_REQUEST':
            return {
                ...state,
                loadingMasterBranch: true,
                MasterBranch: [],
                MasterBranchError: "",
                MasterBranchCurrentPage: 0,
                MasterBranchTotalPage: 0,
                MasterBranchTotalData: 0,
            };
        case 'FIND_MASTER_BRANCH_SUCCESS':
            return {
                ...state,
                loadingMasterBranch: false,
                MasterBranch: action.payload.data,
                MasterBranchCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterBranchTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterBranchTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_BRANCH_FAILURE':
            return {
                ...state,
                loadingMasterBranch: false,
                MasterBranch: action.payload.data,
                MasterBranchCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterBranchTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterBranchTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //branch -> masters lists//


        //branch -> name and id//

        case 'FIND_MASTER_BRANCH_NAME_REQUEST':
            return {
                ...state,
                loadingMasterBranchName: true,
                MasterBranchName: [],
                MasterBranchNameError: "",
            };
        case 'FIND_MASTER_BRANCH_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterBranchName: false,
                MasterBranchName: action.payload.data,
            };
        case 'FIND_MASTER_BRANCH_NAME_FAILURE':
            return {
                ...state,
                loadingMasterBranchName: false,
                MasterBranchNameError: '',
            };
        //branch -> name and id//


        //branch -> masters lists//

        case 'FIND_MASTER_COSTCENTER_REQUEST':
            return {
                ...state,
                loadingMasterCostCenter: true,
                MasterCostCenter: [],
                MasterCostCenterError: "",
                MasterCostCenterCurrentPage: 0,
                MasterCostCenterTotalPage: 0,
                MasterCostCenterTotalData: 0,
            };
        case 'FIND_MASTER_COSTCENTER_SUCCESS':
            return {
                ...state,
                loadingMasterCostCenter: false,
                MasterCostCenter: action.payload.data,
                MasterCostCenterCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCostCenterTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCostCenterTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_COSTCENTER_FAILURE':
            return {
                ...state,
                loadingMasterCostCenter: false,
                MasterCostCenter: action.payload.data,
                MasterCostCenterCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCostCenterTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCostCenterTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //branch -> masters lists//


        //branch -> name and id//

        case 'FIND_MASTER_TAXMASTER_NAME_REQUEST':
            return {
                ...state,
                loadingMasterTaxMasterName: true,
                MasterTaxMasterName: [],
                MasterTaxMasterNameError: "",
            };
        case 'FIND_MASTER_TAXMASTER_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterTaxMasterName: false,
                MasterTaxMasterName: action.payload.data,
            };
        case 'FIND_MASTER_TAXMASTER_NAME_FAILURE':
            return {
                ...state,
                loadingMasterTaxMasterName: false,
                MasterTaxMasterNameError: '',
            };
        //branch -> name and id//

        case 'FIND_MASTER_TAXMASTER_COUNTRIES_REQUEST':
            return {
                ...state,
                loadingMasterTaxMasterCountries: true,
                MasterTaxMasterCountries: [],
                MasterTaxMasterCountriesError: "",
            };
        case 'FIND_MASTER_TAXMASTER_COUNTRIES_SUCCESS':
            return {
                ...state,
                loadingMasterTaxMasterCountries: false,
                MasterTaxMasterCountries: action.payload.data,
            };
        case 'FIND_MASTER_TAXMASTER_COUNTRIES_FAILURE':
            return {
                ...state,
                loadingMasterTaxMasterCountries: false,
                MasterTaxMasterCountriesError: '',
            };
        case 'FIND_MASTER_TAXMASTER_COUNTRY_STATES_REQUEST':
            return {
                ...state,
                loadingMasterTaxMasterCountryStates: true,
                MasterTaxMasterCountryStates: [],
                MasterTaxMasterCountryStatesError: "",
            };
        case 'FIND_MASTER_TAXMASTER_COUNTRY_STATES_SUCCESS':
            return {
                ...state,
                loadingMasterTaxMasterCountryStates: false,
                MasterTaxMasterCountryStates: action.payload.data,
            };
        case 'FIND_MASTER_TAXMASTER_COUNTRY_STATES_FAILURE':
            return {
                ...state,
                loadingMasterTaxMasterCountryStates: false,
                MasterTaxMasterCountryStatesError: '',
            };
        case 'FIND_MASTER_TAXMASTER_DATA_REQUEST':
            return {
                ...state,
                loadingMasterTaxMasterData: true,
                MasterTaxMasterData: {},
                MasterTaxMasterDataError: "",
            };
        case 'FIND_MASTER_TAXMASTER_DATA_SUCCESS':
            return {
                ...state,
                loadingMasterTaxMasterData: false,
                MasterTaxMasterData: action.payload,
            };
        case 'FIND_MASTER_TAXMASTER_DATA_FAILURE':
            return {
                ...state,
                loadingMasterTaxMasterData: false,
                MasterTaxMasterDataError: '',
            };
        //branch -> name and id//

        //branch -> masters lists//

        case 'FIND_MASTER_TAXMASTER_REQUEST':
            return {
                ...state,
                loadingMasterTaxMaster: true,
                MasterTaxMaster: [],
                MasterTaxMasterError: "",
                MasterTaxMasterCurrentPage: 0,
                MasterTaxMasterTotalPage: 0,
                MasterTaxMasterTotalData: 0,
            };
        case 'FIND_MASTER_TAXMASTER_SUCCESS':
            return {
                ...state,
                loadingMasterTaxMaster: false,
                MasterTaxMaster: action.payload.data,
                MasterTaxMasterCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterTaxMasterTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterTaxMasterTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_TAXMASTER_FAILURE':
            return {
                ...state,
                loadingMasterTaxMaster: false,
                MasterTaxMaster: action.payload.data,
                MasterTaxMasterCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterTaxMasterTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterTaxMasterTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //branch -> masters lists//


        //branch -> name and id//

        case 'FIND_MASTER_COSTCENTER_NAME_REQUEST':
            return {
                ...state,
                loadingMasterCostCenterName: true,
                MasterCostCenterName: [],
                MasterCostCenterNameError: "",
            };
        case 'FIND_MASTER_COSTCENTER_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterCostCenterName: false,
                MasterCostCenterName: action.payload.data,
            };
        case 'FIND_MASTER_COSTCENTER_NAME_FAILURE':
            return {
                ...state,
                loadingMasterCostCenterName: false,
                MasterCostCenterNameError: '',
            };
        //branch -> name and id//


        //committed bank -> masters lists//

        case 'FIND_MASTER_COMMITTEDBANK_REQUEST':
            return {
                ...state,
                loadingMasterCommittedBank: true,
                MasterCommittedBank: [],
                MasterCommittedBankError: "",
                MasterCommittedBankCurrentPage: 0,
                MasterCommittedBankTotalPage: 0,
                MasterCommittedBankTotalData: 0,
            };
        case 'FIND_MASTER_COMMITTEDBANK_SUCCESS':
            return {
                ...state,
                loadingMasterCommittedBank: false,
                MasterCommittedBank: action.payload.data,
                MasterCommittedBankCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCommittedBankTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCommittedBankTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_COMMITTEDBANK_FAILURE':
            return {
                ...state,
                loadingMasterCommittedBank: false,
                MasterCommittedBank: action.payload.data,
                MasterCommittedBankCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCommittedBankTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCommittedBankTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //committed bank -> masters lists//


        //committed bank -> name and id//

        case 'FIND_MASTER_COSTCENTER_NAME_REQUEST':
            return {
                ...state,
                loadingMasterCommittedBankName: true,
                MasterCommittedBankName: [],
                MasterCommittedBankNameError: "",
            };
        case 'FIND_MASTER_COSTCENTER_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterCommittedBankName: false,
                MasterCommittedBankName: action.payload.data,
            };
        case 'FIND_MASTER_COSTCENTER_NAME_FAILURE':
            return {
                ...state,
                loadingMasterCommittedBankName: false,
                MasterCommittedBankNameError: '',
            };
        //committed bank -> name and id//



        //rcm category -> masters lists//

        case 'FIND_MASTER_RCM_CATEGORY_REQUEST':
            return {
                ...state,
                loadingMasterRcmCategory: true,
                MasterRcmCategory: [],
                MasterRcmCategoryError: "",
                MasterRcmCategoryCurrentPage: 0,
                MasterRcmCategoryTotalPage: 0,
                MasterRcmCategoryTotalData: 0,
            };
        case 'FIND_MASTER_RCM_CATEGORY_SUCCESS':
            return {
                ...state,
                loadingMasterRcmCategory: false,
                MasterRcmCategory: action.payload.data,
                MasterRcmCategoryCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterRcmCategoryTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterRcmCategoryTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_RCM_CATEGORY_FAILURE':
            return {
                ...state,
                loadingMasterRcmCategory: false,
                MasterRcmCategory: action.payload.data,
                MasterRcmCategoryCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterRcmCategoryTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterRcmCategoryTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //rcm category -> masters lists//


        //rcm category -> name and id//

        case 'FIND_MASTER_RCM_CATEGORY_NAME_REQUEST':
            return {
                ...state,
                loadingMasterRcmCategoryName: true,
                MasterRcmCategoryName: [],
                MasterRcmCategoryNameError: "",
            };
        case 'FIND_MASTER_RCM_CATEGORY_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterRcmCategoryName: false,
                MasterRcmCategoryName: action.payload.data,
            };
        case 'FIND_MASTER_RCM_CATEGORY_NAME_FAILURE':
            return {
                ...state,
                loadingMasterRcmCategoryName: false,
                MasterRcmCategoryNameError: '',
            };
        //rcm category -> name and id//


        // ------------master currency-----------------
        //currency master -> masters lists//

        case 'FIND_MASTER_CURRENCY_REQUEST':
            return {
                ...state,
                loadingMasterCurrency: true,
                MasterCurrency: [],
                MasterCurrencyError: "",
                MasterCurrencyCurrentPage: 0,
                MasterCurrencyTotalPage: 0,
                MasterCurrencyTotalData: 0,
            };
        case 'FIND_MASTER_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingMasterCurrency: false,
                MasterCurrency: action.payload.data,
                MasterCurrencyCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCurrencyTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCurrencyTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_MASTER_CURRENCY_FAILURE':
            return {
                ...state,
                loadingMasterCurrency: false,
                MasterCurrency: action.payload.data,
                MasterCurrencyCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                MasterCurrencyTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                MasterCurrencyTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        //currency master -> masters lists//


        //get all currency master id and name//

        case 'FIND_MASTER_CURRENCY_NAME_REQUEST':
            return {
                ...state,
                loadingMasterCurrencyIdAndName: true,
                MasterCurrencyIdAndName: [],
                MasterCurrencyIdAndNameError: "",
            };
        case 'FIND_MASTER_CURRENCY_NAME_SUCCESS':
            return {
                ...state,
                loadingMasterCurrencyIdAndName: false,
                MasterCurrencyIdAndName: action.payload.data,
            };
        case 'FIND_MASTER_CURRENCY_NAME_FAILURE':
            return {
                ...state,
                loadingMasterCurrencyIdAndName: false,
                MasterCurrencyIdAndNameError: '',
            };
        //get all currency master id and name//



        //get user/company info vis GST//

        case 'FIND_COMPANY_INFO_VIA_GST_REQUEST':
            return {
                ...state,
                loadingCompanyInfoViaGst: true,
                CompanyInfoViaGst: [],
                CompanyInfoViaGstError: "",
            };
        case 'FIND_COMPANY_INFO_VIA_GST_SUCCESS':
            return {
                ...state,
                loadingCompanyInfoViaGst: false,
                CompanyInfoViaGst: action.payload.data,
            };
        case 'FIND_COMPANY_INFO_VIA_GST_FAILURE':
            return {
                ...state,
                loadingCompanyInfoViaGst: false,
                CompanyInfoViaGstError: '',
            };
        //get user/company info vis GST//


        // ReceiptVoucher entry-> search

        case 'FIND_RECEIPT_VOUCHER_REQUEST':
            return {
                ...state,
                loadingReceiptVoucher: true,
                ReceiptVoucher: [],
                ReceiptVoucherError: "",
                ReceiptVoucherCurrentPage: 0,
                ReceiptVoucherTotalPage: 0,
                ReceiptVoucherTotalData: 0,
            };
        case 'FIND_RECEIPT_VOUCHER_SUCCESS':
            return {
                ...state,
                loadingReceiptVoucher: false,
                ReceiptVoucher: action.payload.data,
                ReceiptVoucherCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                ReceiptVoucherTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                ReceiptVoucherTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_RECEIPT_VOUCHER_FAILURE':
            return {
                ...state,
                loadingReceiptVoucher: false,
                ReceiptVoucher: action.payload.data,
                ReceiptVoucherCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                ReceiptVoucherTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                ReceiptVoucherTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };

        // Receipt voucher entry-> search


        //Period Lock-> 

        case 'FIND_ALL_PERIOD_LOCK_REQUEST':
            return {
                ...state,
                loadingPeriodLock: true,
                PeriodLock: [],
                PeriodLockError: "",
                PeriodLockCurrentPage: 0,
                PeriodLockTotalPage: 0,
                PeriodLockTotalData: 0,
            };
        case 'FIND_ALL_PERIOD_LOCK_SUCCESS':
            return {
                ...state,
                loadingPeriodLock: false,
                PeriodLock: action.payload.data,
                PeriodLockCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                PeriodLockTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                PeriodLockTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_ALL_PERIOD_LOCK_FAILURE':
            return {
                ...state,
                loadingPeriodLock: false,
                PeriodLock: action.payload.data,
                PeriodLockCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                PeriodLockTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                PeriodLockTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };

        // Period Lock-> 



        default:
            return state;
    }
}

export default MasterReducer;